<template>
  <div class="searchorders">
    <h1 class="subheading grey--text">Item Editor</h1>

    <v-container class="my-1">
      <v-text-field
        v-model="searchTerm"
        @keyup="doFilter"
        label="Enter item description, name or type"
        prepend-icon="mdi-filter"
        clearable
      ></v-text-field>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="itemList"
        item-key="name"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Edit Item</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on"
                  >New Item</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.description"
                          label="Description"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.item"
                          label="Item"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.type"
                          label="Type"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.priceUsd"
                          label="Price (USD)"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.priceEur"
                          label="Price (EUR)"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.weight"
                          label="Weight"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.packaging"
                          label="Packaging"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <!-- workaround for lint -->
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import cartApi from "../modules/cart-api";

export default {
  components: {},
  data() {
    return {
      dialog: false,
      currentPayment: {},
      cartId: "",
      searchTerm: "",
      itemsRaw: [],
      itemList: [],
      selected: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      loading: false,
      headers: [
        {
          text: "Description",
          align: "start",
          value: "description",
        },
        { text: "Item", value: "item" },
        { text: "Type", value: "type" },
        { text: "USD Price", value: "priceUsd" },
        { text: "EUR Price", value: "priceEur" },
        { text: "Weight", value: "weight" },
        { text: "Packaging", value: "packaging" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  created() {
    this.getItemList();
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    async getItemList() {
      this.loading = true;
      const raw = await cartApi.getAllItems();
      this.itemsRaw = raw.map(item => {
        const prices = item.itemPrices || [];
        const usd = prices.find(p => p.currency === 'usd');
        const eur = prices.find(p => p.currency === 'eur');
        return { ...item, priceUsd: usd ? usd.price : null, priceEur: eur ? eur.price : null };
      });
      await this.doFilter();
      this.loading = false;
    },
    async doFilter() {
      if (!this.searchTerm || this.searchTerm.length == 0) {
        this.itemList = this.itemsRaw;
      } else {
        this.itemList = this.itemsRaw.filter(
          (item) =>
            item.description.includes(this.searchTerm) ||
            item.item.includes(this.searchTerm) ||
            item.type.includes(this.searchTerm)
        );
      }
    },
    editItem(item) {
      this.editedIndex = this.itemList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    async deleteItem(item) {
      const index = this.itemList.indexOf(item);
      await cartApi.deleteItem(this.itemList[index].id);
      this.$toast("Deleted item " + this.itemList[index].id);
      this.getItemList();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      try {
        if (this.editedIndex > -1) {
          Object.assign(this.itemList[this.editedIndex], this.editedItem);
          await cartApi.putItem(
            this.editedItem.id,
            this.editedItem.description,
            this.editedItem.item,
            this.editedItem.type,
            this.editedItem.priceUsd,
            this.editedItem.priceEur,
            this.editedItem.packaging,
            this.editedItem.weight
          );
        } else {
          this.itemList.push(this.editedItem);
          await cartApi.postItem(
            this.editedItem.description,
            this.editedItem.item,
            this.editedItem.type,
            this.editedItem.priceUsd,
            this.editedItem.priceEur,
            this.editedItem.packaging,
            this.editedItem.weight
          );
        }
      } catch (err) {
        this.$toast("Error saving item " + err);
      } finally {
        this.close();
      }
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },
};
</script>
